export const BASE_URL = "https://picsum.photos/id/";
export const COUNT = 20;
export const MAXIMUM_TIME = 120;
